import React from 'react';
import { Phone, Mail, Facebook, Linkedin, Instagram, MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-column">
            <div className="footer-logo">BLS PAINTS</div>
            <p className="footer-tagline">
              Transforming spaces, painting dreams. Your trusted partner in creating lasting impressions.
            </p>
            <div className="footer-badges">
              <span className="footer-badge">Licensed & Insured</span>
              <span className="footer-badge">Quality Guaranteed</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('home')} className="footer-link">Home</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="footer-link">About</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="footer-link">Services</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="footer-link">Contact</button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h4 className="footer-heading">Our Services</h4>
            <ul className="footer-links">
              <li><span className="footer-link">Interior Painting</span></li>
              <li><span className="footer-link">Exterior Painting</span></li>
              <li><span className="footer-link">Texture Finishes</span></li>
              <li><span className="footer-link">Renovation & Remodeling</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="footer-contact">
              <a href="tel:+919929176618" className="footer-contact-item">
                <Phone size={18} />
                <span>+91 9929176618</span>
              </a>
              <a href="mailto:Blspaintsjaipur@gmail.com" className="footer-contact-item">
                <Mail size={18} />
                <span>Blspaintsjaipur@gmail.com</span>
              </a>
              <a 
                href="https://wa.me/919929176618" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-whatsapp-btn"
              >
                <MessageCircle size={18} />
                <span>WhatsApp Us</span>
              </a>
            </div>

            {/* Social Media */}
            <div className="footer-social">
              <a href="#" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <Facebook size={20} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <Linkedin size={20} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            © 2026 BLS Paints. All rights reserved.
          </div>
          <div className="footer-bottom-center">
            Designed and built by Deeptanshu Sharma
          </div>
          <div className="footer-bottom-right" aria-hidden="true" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;